/* ════════════════════════════════════════════════════════════
   O'NEILL × ENCHROMA — PDP INTERACTIONS
   Gallery, lens swatches, tabs, FAQ, vision compare, sticky ATC.
   Self-contained — runs on DOMContentLoaded, scoped to .oneill-pdp.
   ════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {

    // ── GALLERY THUMB SWITCHER (event delegation — robust against re-render timing) ──
    document.addEventListener('click', function (e) {
      var thumb = e.target.closest('.oneill-pdp .gallery-thumbs .thumb');
      if (!thumb) return;
      e.preventDefault();
      var src = thumb.getAttribute('data-src') || (thumb.querySelector('img') && thumb.querySelector('img').src);
      if (!src) return;
      var main = document.querySelector('.oneill-pdp #mainImg');
      if (main) main.src = src;
      var siblings = thumb.parentElement.querySelectorAll('.thumb');
      siblings.forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
    });

    // ── LENS SWATCH PICKER ─────────────────────────────────
    // Each swatch links to a sibling product (different lens, same frame).
    // Clicking it can either:
    //  (a) Hot-swap the gallery hero + sticky ATC + price (if data-src is provided), then
    //  (b) Navigate to the sibling product URL after a short delay (or instantly if href)
    document.querySelectorAll('.oneill-pdp .lens-swatch').forEach(function (swatch) {
      swatch.addEventListener('click', function (e) {
        if (swatch.classList.contains('disabled')) {
          e.preventDefault();
          var soldOut = document.querySelector('.oneill-pdp .sold-out-block');
          if (soldOut) soldOut.classList.add('active');
          return;
        }
        var url = swatch.getAttribute('data-url');
        if (url && url !== '' && url !== '#') {
          window.location.href = url;
          return;
        }
        // No URL → just preview the swap
        document.querySelectorAll('.oneill-pdp .lens-swatch').forEach(function (s) {
          s.classList.remove('active');
        });
        swatch.classList.add('active');
        var name = swatch.getAttribute('data-name');
        var src = swatch.getAttribute('data-src');
        if (name) {
          var sel = document.querySelector('.oneill-pdp #lensSelected');
          if (sel) sel.textContent = name;
          var badge = document.querySelector('.oneill-pdp .gallery-badge');
          if (badge) badge.textContent = 'EnChroma · ' + name;
          var stickyName = document.querySelector('.oneill-pdp-sticky-atc .name');
          if (stickyName) stickyName.textContent = (window.oneillProductTitle || '') + ' · ' + name;
        }
        if (src) {
          var main = document.querySelector('.oneill-pdp #mainImg');
          if (main) main.src = src;
          var stickyImg = document.querySelector('.oneill-pdp-sticky-atc .thumb img');
          if (stickyImg) stickyImg.src = src;
        }
      });
    });

    // ── COLOR (frame variant) PICKER ───────────────────────
    document.querySelectorAll('.oneill-pdp .color-swatch').forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        var group = swatch.closest('.color-swatches');
        if (!group) return;
        group.querySelectorAll('.color-swatch').forEach(function (s) { s.classList.remove('active'); });
        swatch.classList.add('active');
        var name = swatch.getAttribute('data-name');
        var label = swatch.closest('.picker').querySelector('.selected');
        if (name && label) label.textContent = name;
      });
    });

    // ── TABS ───────────────────────────────────────────────
    document.querySelectorAll('.oneill-pdp .tab-btn').forEach(function (btn, i) {
      btn.addEventListener('click', function () {
        var tabs = btn.closest('.tabs');
        if (!tabs) return;
        tabs.querySelectorAll('.tab-btn').forEach(function (b) { b.classList.remove('active'); });
        tabs.querySelectorAll('.tab-content').forEach(function (c) { c.classList.remove('active'); });
        btn.classList.add('active');
        var idx = parseInt(btn.getAttribute('data-tab') || i, 10);
        var content = tabs.querySelectorAll('.tab-content')[idx];
        if (content) content.classList.add('active');
      });
    });

    // ── FAQ ACCORDION ──────────────────────────────────────
    document.querySelectorAll('.oneill-pdp .faq-q').forEach(function (q) {
      q.addEventListener('click', function () {
        q.parentElement.classList.toggle('open');
      });
    });

    // ── VISION COMPARE SLIDER ──────────────────────────────
    var slider = document.querySelector('.oneill-pdp #compareSlider');
    var after = document.querySelector('.oneill-pdp #compareAfter');
    var divider = document.querySelector('.oneill-pdp #compareDivider');
    function updateCompare() {
      if (!slider || !after || !divider) return;
      var v = slider.value;
      after.style.clipPath = 'inset(0 0 0 ' + v + '%)';
      divider.style.left = v + '%';
    }
    if (slider) {
      slider.addEventListener('input', updateCompare);
      updateCompare();
    }

    // ── STICKY ATC VISIBILITY ──────────────────────────────
    var stickyAtc = document.querySelector('.oneill-pdp-sticky-atc');
    var buySection = document.querySelector('.oneill-pdp .buy-section');
    if (stickyAtc && buySection) {
      window.addEventListener('scroll', function () {
        var buyBottom = buySection.offsetTop + buySection.offsetHeight;
        if (window.scrollY > buyBottom - 100 &&
            window.scrollY < document.body.scrollHeight - window.innerHeight - 600) {
          stickyAtc.classList.add('visible');
        } else {
          stickyAtc.classList.remove('visible');
        }
      });
    }

    // ── ATC FORM SUBMIT (Shopify ajax cart fallback) ───────
    document.querySelectorAll('.oneill-pdp [data-pdp-atc]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        // Default Shopify form post still works — this hook is for theme-level interception
        // if the active theme uses ajax cart, dispatch a custom event the theme can listen to.
        var event = new CustomEvent('oneill:atc', { detail: { form: form }, bubbles: true });
        form.dispatchEvent(event);
      });
    });

  });
})();
